module.exports = require('./helpers/bundle-url').getBundleURL('5GWKk') + "privacy-icon.185b896b.png";